/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessOrigin } from './UserAccessOrigin';
import {
    UserAccessOriginFromJSON,
    UserAccessOriginFromJSONTyped,
    UserAccessOriginToJSON,
    UserAccessOriginToJSONTyped,
} from './UserAccessOrigin';
import type { UserAccessContextOrigin } from './UserAccessContextOrigin';
import {
    UserAccessContextOriginFromJSON,
    UserAccessContextOriginFromJSONTyped,
    UserAccessContextOriginToJSON,
    UserAccessContextOriginToJSONTyped,
} from './UserAccessContextOrigin';
import type { OrganizationResponse } from './OrganizationResponse';
import {
    OrganizationResponseFromJSON,
    OrganizationResponseFromJSONTyped,
    OrganizationResponseToJSON,
    OrganizationResponseToJSONTyped,
} from './OrganizationResponse';
import type { UserAccessType } from './UserAccessType';
import {
    UserAccessTypeFromJSON,
    UserAccessTypeFromJSONTyped,
    UserAccessTypeToJSON,
    UserAccessTypeToJSONTyped,
} from './UserAccessType';

/**
 * 
 * @export
 * @interface UserAccessResponse
 */
export interface UserAccessResponse {
    /**
     * 
     * @type {any}
     * @memberof UserAccessResponse
     */
    id?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {Array<OrganizationResponse>}
     * @memberof UserAccessResponse
     */
    organizations?: Array<OrganizationResponse> | null;
    /**
     * 
     * @type {UserAccessType}
     * @memberof UserAccessResponse
     */
    type?: UserAccessType;
    /**
     * 
     * @type {UserAccessOrigin}
     * @memberof UserAccessResponse
     */
    origin?: UserAccessOrigin;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    originDetails?: string | null;
    /**
     * 
     * @type {UserAccessOrigin}
     * @memberof UserAccessResponse
     */
    parentOrigin?: UserAccessOrigin;
    /**
     * 
     * @type {UserAccessContextOrigin}
     * @memberof UserAccessResponse
     */
    contextOrigin?: UserAccessContextOrigin;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    parentOriginDetails?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserAccessResponse
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessResponse
     */
    entraSecurityGroupId?: string | null;
}



/**
 * Check if a given object implements the UserAccessResponse interface.
 */
export function instanceOfUserAccessResponse(value: object): value is UserAccessResponse {
    return true;
}

export function UserAccessResponseFromJSON(json: any): UserAccessResponse {
    return UserAccessResponseFromJSONTyped(json, false);
}

export function UserAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'organizations': json['organizations'] === undefined ? undefined : json['organizations'] === null ? null : ((json['organizations'] as Array<any>).map(OrganizationResponseFromJSON)),
        'type': json['type'] == null ? undefined : UserAccessTypeFromJSON(json['type']),
        'origin': json['origin'] == null ? undefined : UserAccessOriginFromJSON(json['origin']),
        'originDetails': json['originDetails'] === undefined ? undefined : json['originDetails'] === null ? null : json['originDetails'],
        'parentOrigin': json['parentOrigin'] == null ? undefined : UserAccessOriginFromJSON(json['parentOrigin']),
        'contextOrigin': json['contextOrigin'] == null ? undefined : UserAccessContextOriginFromJSON(json['contextOrigin']),
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'parentOriginDetails': json['parentOriginDetails'] === undefined ? undefined : json['parentOriginDetails'] === null ? null : json['parentOriginDetails'],
        'expirationDate': json['expirationDate'] === undefined ? undefined : json['expirationDate'] === null ? null : (new Date(json['expirationDate'])),
        'entraSecurityGroupId': json['entraSecurityGroupId'] === undefined ? undefined : json['entraSecurityGroupId'] === null ? null : json['entraSecurityGroupId'],
    };
}

export function UserAccessResponseToJSON(json: any): UserAccessResponse {
    return UserAccessResponseToJSONTyped(json, false);
}

export function UserAccessResponseToJSONTyped(value?: UserAccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'shortName': value['shortName'],
        'applicationName': value['applicationName'],
        'organizations': value['organizations'] == null ? undefined : ((value['organizations'] as Array<any>).map(OrganizationResponseToJSON)),
        'type': UserAccessTypeToJSON(value['type']),
        'origin': UserAccessOriginToJSON(value['origin']),
        'originDetails': value['originDetails'],
        'parentOrigin': UserAccessOriginToJSON(value['parentOrigin']),
        'contextOrigin': UserAccessContextOriginToJSON(value['contextOrigin']),
        'userId': value['userId'],
        'parentOriginDetails': value['parentOriginDetails'],
        'expirationDate': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString(),
        'entraSecurityGroupId': value['entraSecurityGroupId'],
    };
}

